import { DialogConfirm } from 'components'
import NotFoundMessage from 'components/NotFoundMessage'
import React, { useState } from 'react'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import { sortByQuestionStatus } from 'utils/sorters'
import { USER_ROLES } from 'utils/constants/userRoles'

import AdditionalQuestionAnswer from '../AdditionalQuestionAnswer'
import QuestionItem from '../QuestionItem'
import styles from './styles'
import AdditionalAnswerForm from '../AdditionalAnswerForm'

const AdditionalQuestionInfo = (props) => {
  const classes = styles()
  const { reloadData } = props
  const questions = sortByQuestionStatus(props.questions)
  const token = useSelector((state) => state.auth.access_token)
  const firstName = jwtDecode(token)?.extras?.name?.split(' ')[0]

  const currentRole = jwtDecode(token)?.extras?.role

  const message =
    currentRole === USER_ROLES.PROSPECT
      ? `${firstName}, não há ainda nenhuma pergunta adicional a ser respondida, porém a qualquer momento nossa equipe poderá solicitar eventuais esclarecimentos. Caso receba uma pergunta adicional, você será notificado por e-mail.`
      : 'Nenhuma pergunta adicional encontrada'

  const [open, setOpen] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState(null)

  const handleOpenQuestion = (question) => {
    setCurrentQuestion(question)
    setOpen(true)
  }

  const handleClose = () => {
    setCurrentQuestion(null)
    reloadData()
    setOpen(false)
  }

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <h2>Perguntas Adicionais</h2>
      </header>
      {currentRole === USER_ROLES.PROSPECT
        ? 'As perguntas adicionais são feitas pelos recrutadores da XP sobre alguma resposta dada no formulário, a critério da equipe.'
        : 'As perguntas adicionais são feitas pelos recrutadores da XP sobre alguma resposta dada no formulário ou algum apontamento no Background Check, a critério da equipe.'}
      <p></p>
      <br></br>
      <div className={classes.questionsContainer}>
        {questions?.length > 0 ? (
          questions.map((question) => (
            <QuestionItem
              key={question.uuid}
              question={question}
              action={() => handleOpenQuestion(question)}
            />
          ))
        ) : (
          <NotFoundMessage message={message} />
        )}
      </div>
      {currentQuestion && open ? (
        <DialogConfirm open={open} onCancel={handleClose} btnCancelText="Fechar" maxWidth="custom">
          {currentQuestion.answered || currentRole !== USER_ROLES.PROSPECT ? (
            <AdditionalQuestionAnswer questionData={currentQuestion} />
          ) : (
            <AdditionalAnswerForm questionData={currentQuestion} handleClose={handleClose}/>
          )}
        </DialogConfirm>
      ) : null}
    </div>
  )
}

export default AdditionalQuestionInfo
